<app-complex-modal-template
    [canConfirm]="layerForm.valid"
    [title]="'createNewLayer' | transloco"
    (onClickEvent)="onClickEvent($event)">
    <form
        class="flex flex-col min-h-0"
        [formGroup]="layerForm">
        <div class="flex w-3/4 ml-2 gap-4">
            <app-input-text
                [errors]="getNameErrors(layerForm.controls.name)"
                [inputFormControl]="layerForm.controls.name"
                [label]="'layerName' | transloco"
                [placeholder]="'layerName' | transloco" />
        </div>

        <app-custom-table
            class="m-2 flex-1 min-h-0 overflow-auto"
            [columns]="customColumns"
            [translateColumns]="true">
            @for (row of columnProperties.controls; track row) {
                <tr>
                    <td>
                        @switch (row.controls.type.value) {
                            @case (ColumnType.GEOM) {
                                <div class="flex flex-col justify-center">
                                    <p class="!m-0 text-base pl-2.5">{{ row.controls.name.value }}</p>
                                </div>
                            }
                            @default {
                                <app-input-text
                                    additionalClasses="!bg-white !py-2.5"
                                    [errors]="getNameErrors(row.controls.name, row)"
                                    [inputFormControl]="row.controls.name"
                                    [placeholder]="'fieldName' | transloco" />
                            }
                        }
                    </td>

                    <td>
                        <app-select
                            additionalClasses="!bg-white"
                            [defaultValue]="typeDefaultOption"
                            [inputFormControl]="row.controls.type"
                            [options]="typeOptions()"
                            (resetValue)="resetType(row)"
                            (selectedOptionsChange)="selectedTypeChange($event, row)" />
                    </td>

                    <td>
                        @switch (row.controls.type.value) {
                            @case (ColumnType.STRING) {
                                <app-input-number
                                    additionalClasses="!bg-white !py-2.5"
                                    [inputFormControl]="row.controls.length"
                                    [max]="254"
                                    [min]="1"
                                    [placeholder]="'fieldMaxLength' | transloco" />
                            }
                            @case (ColumnType.GEOM) {
                                <div class="flex flex-col gap-0.5">
                                    @if (layerForm.controls.geometryType.value === null) {
                                        <span class="text-error text-xs">
                                            {{ 'required' | transloco }}
                                        </span>
                                    }
                                    <app-select
                                        additionalClasses="!bg-white"
                                        placeholder="geom"
                                        [defaultValue]="geometryTypeDefaultValue()"
                                        [inputFormControl]="layerForm.controls.geometryType"
                                        [options]="geometryTypeOptions"
                                        (selectedOptionsChange)="selectedGeometryTypeChange($event)" />
                                </div>
                            }
                            @default {
                                <div class="flex flex-col justify-center">
                                    <p class="!m-0 text-base pl-2.5">
                                        {{ attributeFormatByType[row.controls.type.value!] ?? '-' }}
                                    </p>
                                </div>
                            }
                        }
                    </td>

                    <td>
                        <app-checkbox
                            [checkboxState]="
                                row.controls.required.value ? CheckboxState.CHECKED : CheckboxState.UNCHECKED
                            "
                            [disabled]="row.controls.type.value === ColumnType.GEOM"
                            (click)="row.controls.required.setValue(!row.controls.required.value)" />
                    </td>

                    <td>
                        <div class="flex flex-row m-auto justify-center">
                            <button
                                class="bg-transparent text-on-surface hover:text-red-600 hover:bg-red-200 border-none rounded-full aspect-square p-2"
                                (click)="removeRow($index)">
                                <fa-icon
                                    class="delete-icon"
                                    [icon]="['fas', 'trash']" />
                            </button>
                        </div>
                    </td>
                </tr>
            }
        </app-custom-table>
        <app-button
            [disabled]="layerForm.invalid || layerForm.controls.columnProperties.length >= ATTRIBUTE_LIMIT"
            [icon]="['fas', 'plus']"
            [label]="'addField' | transloco"
            [type]="ButtonType.SECONDARY"
            (click)="addRow()" />
    </form>
</app-complex-modal-template>
